var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-tasklists account-lookup " },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _vm.masterAdmin == true ? _c("masteradmin-sidebar-menu") : _vm._e(),
          _vm._v(" "),
          _vm.researcher == true ? _c("researcher-sidebar-menu") : _vm._e(),
          _vm._v(" "),
          _vm.csr == true ? _c("CSRSidebarMenu") : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper" }, [
            _c(
              "div",
              { staticClass: "container-wrapper center report-dasboard" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "heading-seperator" }),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-bottom": "15px" } }),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-3 float-left" }, [
                    _c(
                      "div",
                      { staticClass: "panel panel-grey" },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          { attrs: { to: "/account-report" } },
                          [
                            _c("div", { staticClass: "panel-footer" }, [
                              _c("span", { staticClass: "pull-left" }, [
                                _vm._v("go to ")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "pull-right" }, [
                                _c("i", {
                                  staticClass: "fa fa-chevron-right",
                                  attrs: { "aria-hidden": "true" }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" })
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-3 float-left" }, [
                    _c(
                      "div",
                      { staticClass: "panel panel-grey" },
                      [
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          { attrs: { to: "/account-contact-report" } },
                          [
                            _c("div", { staticClass: "panel-footer" }, [
                              _c("span", { staticClass: "pull-left" }, [
                                _vm._v("go to ")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "pull-right" }, [
                                _c("i", {
                                  staticClass: "fa fa-chevron-right",
                                  attrs: { "aria-hidden": "true" }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" })
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.masterAdmin == true
                    ? _c("div", { staticClass: "col-3 float-left" }, [
                        _c(
                          "div",
                          { staticClass: "panel panel-grey" },
                          [
                            _vm._m(3),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              { attrs: { to: "/activity-report" } },
                              [
                                _c("div", { staticClass: "panel-footer" }, [
                                  _c("span", { staticClass: "pull-left" }, [
                                    _vm._v("go to ")
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "pull-right" }, [
                                    _c("i", {
                                      staticClass: "fa fa-chevron-right",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clearfix" })
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.masterAdmin == true
                    ? _c("div", { staticClass: "col-3 float-left" }, [
                        _c(
                          "div",
                          { staticClass: "panel panel-grey" },
                          [
                            _vm._m(4),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              { attrs: { to: "/flash-report" } },
                              [
                                _c("div", { staticClass: "panel-footer" }, [
                                  _c("span", { staticClass: "pull-left" }, [
                                    _vm._v("go to ")
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "pull-right" }, [
                                    _c("i", {
                                      staticClass: "fa fa-chevron-right",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clearfix" })
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-3 float-left" }, [
                    _c(
                      "div",
                      { staticClass: "panel panel-grey" },
                      [
                        _vm._m(5),
                        _vm._v(" "),
                        _c("router-link", { attrs: { to: "/usage-report" } }, [
                          _c("div", { staticClass: "panel-footer" }, [
                            _c("span", { staticClass: "pull-left" }, [
                              _vm._v("go to ")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "pull-right" }, [
                              _c("i", {
                                staticClass: "fa fa-chevron-right",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" })
                          ])
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-3 float-left" }, [
                    _c(
                      "div",
                      { staticClass: "panel panel-grey" },
                      [
                        _vm._m(6),
                        _vm._v(" "),
                        _c("router-link", { attrs: { to: "/mentee-report" } }, [
                          _c("div", { staticClass: "panel-footer" }, [
                            _c("span", { staticClass: "pull-left" }, [
                              _vm._v("go to ")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "pull-right" }, [
                              _c("i", {
                                staticClass: "fa fa-chevron-right",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" })
                          ])
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { clear: "both" } })
                ])
              ]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 override-padding" }, [
      _c("h3", { staticClass: "d-inline heading" }, [
        _vm._v("Report Dashboard")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-3 float-left" }, [
          _c("i", { staticClass: "fa fa-cog" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-9 text-right float-right" }, [
          _c("div", { staticClass: "panel-main-title more-options-panel" }, [
            _vm._v("Accounts")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { clear: "both" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-3 float-left" }, [
          _c("i", { staticClass: "fa fa-user" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-9 text-right float-right" }, [
          _c("div", { staticClass: "panel-main-title more-options-panel" }, [
            _vm._v("Account Contacts")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { clear: "both" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-3 float-left" }, [
          _c("i", { staticClass: "fa fa-user" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-9 text-right float-right" }, [
          _c("div", { staticClass: "panel-main-title more-options-panel" }, [
            _vm._v("Activity Report")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { clear: "both" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-3 float-left" }, [
          _c("i", { staticClass: "fa fa-user" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-9 text-right float-right" }, [
          _c("div", { staticClass: "panel-main-title more-options-panel" }, [
            _vm._v("Flash Report")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { clear: "both" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-3 float-left" }, [
          _c("i", { staticClass: "fa fa-cog" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-9 text-right float-right" }, [
          _c("div", { staticClass: "panel-main-title more-options-panel" }, [
            _vm._v("Usage Report")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { clear: "both" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-3 float-left" }, [
          _c("i", { staticClass: "fa fa-cog" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-9 text-right float-right" }, [
          _c("div", { staticClass: "panel-main-title more-options-panel" }, [
            _vm._v("Mentee Report")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { clear: "both" } })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61c6782e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61c6782e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/reports/report_dashboard.vue
// module id = null
// module chunks = 